import type { CasePhoto, PhotoStage } from '../types/admin'

/** Mappenavn i Firebase Storage for hvert trin: cases/{caseId}/before|during|after/… */
export const stageFolder: Record<PhotoStage, 'before' | 'during' | 'after'> = {
  Før: 'before',
  'Under arbejdet': 'during',
  Efter: 'after',
}

/** Feltnavn i Firestore-dokumentet for hvert trin. */
export const stageField: Record<PhotoStage, 'beforeImages' | 'duringImages' | 'afterImages'> = {
  Før: 'beforeImages',
  'Under arbejdet': 'duringImages',
  Efter: 'afterImages',
}

/** Stier pr. trin, udledt af sagens billeder — holder felterne i sync. */
export function stagePaths(photos: CasePhoto[]) {
  return {
    beforeImages: photos.filter((photo) => photo.stage === 'Før').map((photo) => photo.path),
    duringImages: photos
      .filter((photo) => photo.stage === 'Under arbejdet')
      .map((photo) => photo.path),
    afterImages: photos.filter((photo) => photo.stage === 'Efter').map((photo) => photo.path),
  }
}
